// Data source presets for chart & table widgets.
// Each key maps to a realistic column/dataset shape that mirrors what the
// corresponding integration (Google Ads, GA4, Search Console) returns.
// When a live integration is connected, the backend populates these keys with
// real rows. Until then every dataset is empty on purpose: a widget with no
// source renders an empty state rather than invented rows.

export const DATA_SOURCE_OPTIONS = [
  { value: '', label: 'No data source selected' },
  { value: 'ga4_channels', label: 'Analytics \u2013 Traffic by Channel' },
  { value: 'ga4_landing_pages', label: 'Analytics \u2013 Top Landing Pages' },
  { value: 'ga4_sessions_trend', label: 'Analytics \u2013 Sessions Trend' },
  { value: 'gsc_top_queries', label: 'Search Console \u2013 Top Queries' },
  { value: 'gsc_top_pages', label: 'Search Console \u2013 Top Pages' },
  { value: 'gsc_clicks_trend', label: 'Search Console \u2013 Clicks Trend' },
  { value: 'ads_campaigns', label: 'Google Ads \u2013 Campaign Performance' },
  { value: 'ads_spend_by_type', label: 'Google Ads \u2013 Spend by Campaign Type' },
  { value: 'ads_paid_vs_organic', label: 'Google Ads \u2013 Paid vs Organic' },
];

export const DATA_SOURCE_PRESETS = {
  ga4_channels: {
    data: [],
  },
  ga4_landing_pages: {
    columns: [
      { key: 'page', label: 'Landing Page', type: 'text' },
      { key: 'sessions', label: 'Sessions', type: 'number' },
      { key: 'bounce_rate', label: 'Bounce Rate', type: 'percentage' },
      { key: 'avg_duration', label: 'Avg. Duration', type: 'text' },
      { key: 'conversions', label: 'Conversions', type: 'number' },
    ],
    data: [],
  },
  ga4_sessions_trend: {
    data: [],
  },
  gsc_top_queries: {
    columns: [
      { key: 'query', label: 'Query', type: 'text' },
      { key: 'clicks', label: 'Clicks', type: 'number' },
      { key: 'impressions', label: 'Impressions', type: 'number' },
      { key: 'ctr', label: 'CTR', type: 'percentage' },
      { key: 'position', label: 'Avg. Position', type: 'number' },
    ],
    data: [],
  },
  gsc_top_pages: {
    columns: [
      { key: 'page', label: 'Page', type: 'text' },
      { key: 'clicks', label: 'Clicks', type: 'number' },
      { key: 'impressions', label: 'Impressions', type: 'number' },
      { key: 'ctr', label: 'CTR', type: 'percentage' },
      { key: 'position', label: 'Avg. Position', type: 'number' },
    ],
    data: [],
  },
  gsc_clicks_trend: {
    data: [],
  },
  ads_campaigns: {
    columns: [
      { key: 'campaign', label: 'Campaign', type: 'text' },
      { key: 'spend', label: 'Spend', type: 'currency' },
      { key: 'clicks', label: 'Clicks', type: 'number' },
      { key: 'conversions', label: 'Conversions', type: 'number' },
      { key: 'roas', label: 'ROAS', type: 'number' },
    ],
    data: [],
  },
  ads_spend_by_type: {
    data: [],
  },
  ads_paid_vs_organic: {
    data: [],
  },
};

export function getPreset(dataSource) {
  if (!dataSource) return null;
  return DATA_SOURCE_PRESETS[dataSource] || null;
}
